import React from 'react';
import { IconProps } from './types';

const UnMuteIcon: React.FC<IconProps> = props => {
  const {
    height = '24',
    width = '24',
    fillColor = 'var(--grayscale-3)',
    onClick = () => {}
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_14977_208632" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14977_208632)">
        <path
          d="M17.75 14.95L16.3 13.5C16.45 13.25 16.5791 12.9917 16.6875 12.725C16.7958 12.4583 16.875 12.1833 16.925 11.9C16.975 11.65 17.0958 11.4375 17.2875 11.2625C17.4791 11.0875 17.6916 11 17.925 11C18.2416 11 18.5 11.1083 18.7 11.325C18.9 11.5417 18.975 11.7917 18.925 12.075C18.8416 12.6083 18.7 13.1125 18.5 13.5875C18.3 14.0625 18.05 14.5167 17.75 14.95ZM14.8 11.95L8.99995 6.15V5C8.99995 4.16667 9.29162 3.45833 9.87495 2.875C10.4583 2.29167 11.1666 2 12 2C12.8333 2 13.5416 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5V11C15 11.1833 14.9791 11.35 14.9375 11.5C14.8958 11.65 14.85 11.8 14.8 11.95ZM19.1 21.9L2.09995 4.9C1.91662 4.71667 1.82495 4.48333 1.82495 4.2C1.82495 3.91667 1.91662 3.68333 2.09995 3.5C2.28328 3.31667 2.51662 3.225 2.79995 3.225C3.08328 3.225 3.31662 3.31667 3.49995 3.5L20.5 20.5C20.6833 20.6833 20.775 20.9167 20.775 21.2C20.775 21.4833 20.6833 21.7167 20.5 21.9C20.3166 22.0833 20.0833 22.175 19.8 22.175C19.5166 22.175 19.2833 22.0833 19.1 21.9ZM11 20V17.9C9.44995 17.7 8.13328 17.0583 7.04995 15.975C5.96662 14.8917 5.30828 13.5917 5.07495 12.075C5.02495 11.7917 5.09995 11.5417 5.29995 11.325C5.49995 11.1083 5.76662 11 6.09995 11C6.33328 11 6.54162 11.0875 6.72495 11.2625C6.90828 11.4375 7.02495 11.65 7.07495 11.9C7.29162 13.0667 7.85828 14.0417 8.77495 14.825C9.69162 15.6083 10.7666 16 12 16C12.5666 16 13.1041 15.9125 13.6125 15.7375C14.1208 15.5625 14.5833 15.3167 15 15L16.425 16.425C15.9416 16.8083 15.4125 17.1292 14.8375 17.3875C14.2625 17.6458 13.65 17.8167 13 17.9V20C13 20.2833 12.9041 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21C11.7166 21 11.4791 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};
export default UnMuteIcon;
